import React from "react";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="app">
      <Header />
      <main className="app__content">
        <Home />
      </main>
      <Footer />
    </div>
  );
}

export default App;
